import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { logAction } from '../../_actions';
import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  TablePagination,
  Paper
} from "@material-ui/core"
import HistoryIcon from '@material-ui/icons/History';
import { PaginationActions, PedidoCompraSituacaoBadge } from 'components'
import moment from 'moment'
import TipoLog from '../../utils/enums/tipoLog';
import { Skeleton } from '@material-ui/lab';

const EditorHeader = ({ title, tabela, chave, props, situacao, numero }) => {
  const dispatch = useDispatch()
  const { log, totalRegistros, isLoading } = props.log
  const { page, limit, term, direction, order } = useSelector(state => state.log);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(logAction.clear());
  }, [])

  useEffect(() => {
    handleChangePage(null, 0);
  }, [totalRegistros])

  const fetchData = () => {
    if (tabela && chave) {
      let filterModel = {
        Tabela: tabela,
        Chave: chave,
        Page: page || 0,
        Limit: limit || 10,
        Term: term || '',
        Order: 'dataHora',
        Direction: 'desc'
      };

      dispatch(logAction.getLog(filterModel, true));
    }
  };

  const handleClickOpen = () => {
    fetchData();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = prop => event => {
    dispatch(logAction.onChangeProps(prop, event))
  };

  const handleChangePage = (_, value) => {
    const fakeEvent = {
      type: 'text',
      target: {
        value
      }
    }
    dispatch(logAction.onChangeProps('page', fakeEvent))
  }

  useEffect(() => {
    if (open) {
      fetchData();
    }
  }, [page, limit, term, direction, order]);

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4">
          <b>{title}</b>
        </Typography>
        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
          {situacao != null && situacao !== '' && (
            <PedidoCompraSituacaoBadge situacao={situacao} numero={numero} />
          )}
          <Tooltip title='Exibir Histórico de Modificações'>
            <IconButton
              onClick={handleClickOpen}
              aria-label="logs"
              size="small"
            >
              <HistoryIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle>
          <Typography style={{ fontSize: "16px", fontWeight: 'bold', textAlign: "left", marginRight: 5 }}>
            HISTÓRICO DE MODIFICAÇÕES
          </Typography>
          <Typography style={{ fontSize: "12px", textAlign: "left", marginRight: 5, color: '#7C7C7C' }}>
            {'Chave do registro: ' + chave}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table style={{ minWidth: '100%' }}>
              <TableHead>
                <TableRow>
                  <TableCell>Data/Hora</TableCell>
                  <TableCell>Usuário</TableCell>
                  <TableCell>Tipo</TableCell>
                  <TableCell>Tabela</TableCell>
                  <TableCell>Chave</TableCell>
                  <TableCell>Campo</TableCell>
                  <TableCell>Valor Antigo</TableCell>
                  <TableCell>Valor Novo</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {undefined !== log && log.length
                  ? log.map((n) => {
                    return (
                      <TableRow hover key={n.id}>
                        <TableCell component="th" scope="row">
                          {moment(n.dataHora).format('DD/MM/YYYY HH:mm')}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {n.usuario}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {TipoLog[n.tipo]}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {n.tabela}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {n.chave}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {n.campo}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {n.valorAntigo}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {n.valorNovo}
                        </TableCell>
                      </TableRow>
                    )
                  })
                  :
                  (
                    isLoading ?
                      Array.apply(null, { length: 6 }).map((e, i) => (
                        <TableRow hover>
                          <TableCell component="th" scope="row">
                            <Skeleton animation="wave" />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton animation="wave" />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton animation="wave" />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton animation="wave" />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton animation="wave" />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton animation="wave" />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton animation="wave" />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton animation="wave" />
                          </TableCell>
                        </TableRow>
                      ))
                      :
                      <TableRow>
                        <TableCell rowSpan={3} colSpan={7} align="center">Nenhum registro encontrado</TableCell>
                      </TableRow>
                  )
                }
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={totalRegistros}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={limit}
            onRowsPerPageChange={handleChange('limit')}
            ActionsComponent={PaginationActions}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default EditorHeader
